<template>
  <div>
    <Header />
    <hero-section />
    <calculator-section :content="calculator" />
    <infos-process-section />
    <scenario-section :content="scenarios" :simulationContent="simulation" />
    <questions-section />
    <agreements-dialog v-if="isVisible" />
    <Footer />
  </div>
</template>

<script>

import InfosProcessSection from '../../components/infos/InfosProcessSection'

import AgreementsDialog from '../../components/agreements/AgreementsDialog'
import ScenarioSection from '../../components/scenarios/ScenarioSection'
import CalculatorSection from '../../components/calculator/CalculatorSection'
import QuestionsSection from '../../components/questions/QuestionsSection'
import HeroSection from '../../components/hero/HeroSection'
import ContentMixin from '../../mixins/content.mixin'
import Footer from '../../components/Footer.vue'
import Header from './components/Header.vue'

export default {
  name: 'DefaultLayout',
  components: {
    InfosProcessSection,
    AgreementsDialog,
    ScenarioSection,
    CalculatorSection,
    QuestionsSection,
    HeroSection,
    Footer,
    Header
  },
  mixins: [ContentMixin]
}
</script>
<style lang="scss" src='../../assets/scss/style.scss'></style>
